query WfaSessionName($runId: ConditionID!) {
	wfa_session_runs(run_id_eq: $runId) {
		session_name
	}
}
